import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';


export class RadioButtonOptionModel {
    label: string;
    key: string;
    disabled?: boolean;
    tooltip?: string;
    subRadioOptions?: RadioButtonOptionModel[];
    enableCondition?: (displayElement: DisplayElementModel) => boolean;
    displayRadioButton?: boolean;

    constructor(
        label: string,
        key: string,
        disabled: boolean = false,
        tooltip: string = '',
        subRadioOptions?: RadioButtonOptionModel[],
        enableConditon?: (displayElement: DisplayElementModel) => boolean,
        displayRadioButton: boolean = true
    ) {
        this.label = label;
        this.key = key;
        this.disabled = disabled;
        this.tooltip = tooltip;
        this.subRadioOptions = subRadioOptions;
        this.enableCondition = enableConditon;
        this.displayRadioButton = displayRadioButton;
    }
}
